import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import apiInstance from '../../api/api';
import {logout} from "../auth/authSlice";
import {handleAxiosError} from "../../utils/axiosErrorHandler";
import {ApiFailResponse} from "../../utils/interfaces/apiTypes";
import apiEndpoints from '../../utils/api/endpoints';

export interface PersonalDataProfileSlice {
    loading: boolean,
    firstName: string,
    lastName: string,
    birthdate: string,
    email: string,
    agreement_mk: boolean,
    agreement_sms: boolean,
    agreement_email: boolean,
    error: string,
};

const initialState: PersonalDataProfileSlice = {
    loading: false,
    firstName: '',
    lastName: '',
    birthdate: '',
    email: '',
    agreement_mk: false,
    agreement_sms: false,
    agreement_email: false,
    error: '',
}


export const getPersonalData = createAsyncThunk(
    'contact/getPersonalData',
    async (_, thunkAPI) => {
        try {
            const response = await apiInstance.get(apiEndpoints.contactGetPersonalData);

            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(handleAxiosError(error) as ApiFailResponse);
        }
    }
);

const personalDataProfileSlice = createSlice({
    name: "profile/personalData",
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getPersonalData.pending, (state) => {
                state.loading = true;
                state.error = '';
            })
            .addCase(getPersonalData.fulfilled, (state, action: any) => {
                state.loading = false;
                state.firstName = action.payload.data.firstname;
                state.lastName = action.payload.data.lastname;
                state.birthdate = action.payload.data.birthdate;
                state.email = action.payload.data.email;
                state.agreement_mk = action.payload.data.agreement_mk;
                state.agreement_sms = action.payload.data.agreement_sms;
                state.agreement_email = action.payload.data.agreement_email;
            })
            .addCase(getPersonalData.rejected, (state, action: any) => {
                state.loading = false;
                state.error = action.payload.message;
            })
            .addCase(logout, (state) => initialState)
        ;
    }
});

// export const {} = profileSlice.actions
export default personalDataProfileSlice.reducer;